interface Flag {
  active: boolean
  note: string
}

interface Flags {
  activation_maintenance?: Flag
}

function getFlags(): Flags {
  const el = document.getElementById('flags-data')
  return el ? JSON.parse(el.textContent || '{}') : {}
}

export default getFlags()
